exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.qqun[data-v-f43983c8] {\n\tdisplay: inline;\n\n\tline-height: 40px;\n\n\tfloat: left;\n\tmargin-left: 1rem\n}\n#footer[data-v-f43983c8] {\n\tbackground-color: #2C405A;\n}\n.footlink[data-v-f43983c8] {\n\tfont-size: 16px;\n}\n.logo[data-v-f43983c8]{\n \n\t    image-rendering: -moz-crisp-edges; /* Firefox */\n\t    image-rendering: -o-crisp-edges; /* Opera */\n\t    image-rendering: -webkit-optimize-contrast; /* Webkit (non-standard naming) */\n\t    image-rendering: crisp-edges;    -ms-interpolation-mode: nearest-neighbor; /* IE (non-standard property) */\n}\n", ""]);

// exports
